import _slicedToArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { detailData } from '../component/config.js';
import staffSearch from '_c/staff-search';
import Pagination from '_c/pagination';
export default {
  components: {
    staffSearch: staffSearch,
    Pagination: Pagination
  },
  data: function data() {
    return {
      params: this.$route.params,
      query: this.$route.query,
      detailData: detailData,
      formData: {},
      sendDate: '',
      page: {
        pageSizes: [20, 50, 100],
        total: 0
      },
      deleteLoa: false,
      loading: false,
      selectLoa: false,
      row: {},
      tableData: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    contentViewHeight: function contentViewHeight(state) {
      return state.settings.contentViewHeight;
    }
  })), {}, {
    tableHeight: function tableHeight() {
      return this.contentViewHeight - 118;
    },
    detail: function detail() {
      return this.detailData[6];
    },
    selectData: function selectData() {
      return this.detail.selectData;
    }
  }),
  created: function created() {
    this.getHistoryList(1);
    this.$route.meta.title = this.detail.title;
  },
  methods: {
    // 返回列表页
    handlerBack: function handlerBack() {
      this.$router.push({
        path: this.selectData.goPath
      });
    },
    // 选择员工信息
    staffChange: function staffChange(val, item) {
      this.detail.query[item] = val.staff_id;
    },
    sendDateChange: function sendDateChange(v) {
      if (v) {
        var _v = _slicedToArray(v, 2),
          start = _v[0],
          end = _v[1];
        this.detail.query.start_time = start;
        this.detail.query.end_time = end;
      } else {
        this.detail.query.start_time = '';
        this.detail.query.end_time = '';
      }
    },
    clickSelect: function clickSelect() {
      this.selectLoa = true;
      this.getHistoryList(1);
    },
    // 获取列表
    getHistoryList: function getHistoryList(page) {
      var _this = this;
      this.detail.query.page = page;
      var api = this.detail.api;
      this.loading = true;
      api.listData(this.detail.query).then(function (res) {
        _this.tableData = res.data.list;
        _this.page.total = res.data.page_data.total;
      }).finally(function () {
        _this.loading = false;
        _this.deleteLoa = false;
        _this.selectLoa = false;
      });
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.getHistoryList(page);
    },
    handleSizeChange: function handleSizeChange(size) {
      this.detail.query.page_size = size;
      this.getHistoryList(1);
    },
    // 重置
    clickReset: function clickReset() {
      this.$refs.staff.res = {};
      this.$refs.staff.supOptions = [];
      this.$refs.operate.res = {};
      this.$refs.operate.supOptions = [];
      this.detail.query.certificate_state = '';
      this.detail.query.staff_id = '';
      this.detail.query.operate_id = '';
      this.detail.query.start_time = '';
      this.detail.query.end_time = '';
      this.detail.query.type = [];
      this.detail.query.page = 1;
      this.detail.query.page_size = 100;
      this.deleteLoa = true;
      this.getHistoryList(1);
    },
    // 查看
    clickView: function clickView(row) {
      var object_url = row.oss_link[0] ? row.oss_link[0].object_url : row.oss_link.object_url;
      window.open(object_url, '_blank');
    }
  }
};